import fetch from 'auth/FetchInterceptor'

const notificationService = {}
const apiRoute = '/notification'

notificationService.get = async function (paginationQuery = '', query = '') {
  try {
    const res = await fetch({
      url: `${apiRoute}/getAll/admin${paginationQuery}${query}`,
      method: 'get',
    })
    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}

notificationService.getAll = async function (query = '') {
  try {
    const res = await fetch({
      url: `${apiRoute}/getAll${query}`,
      method: 'get',
    })
    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}

notificationService.readAll = async function () {
  try {
    const res = await fetch({
      url: `${apiRoute}/read/all`,
      method: 'put',
    })
    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}

notificationService.read = async function (data) {
  try {
    const res = await fetch({
      url: `${apiRoute}/read`,
      method: 'put',
      data,
    })
    return res
  } catch (err) {
    console.log(err, 'show-err')
  }
}

notificationService.readIds = notificationService.read

/** @deprecated use notificationService.get */
notificationService.getNotifications = async function (paginationQuery = '', query = '') {
  return notificationService.get(paginationQuery, query)
}

notificationService.createNotifications = async function (data) {
    try {
      const res = await fetch({
        url:`${apiRoute}/general` ,
        method: 'post',
        data: data,
      })
      return res
    } catch (err) {
      console.log(err, 'show-err')
    }
  }

  notificationService.getNotificationsById = async function (id) {
    try {
      const res = await fetch({
        url:`${apiRoute}/${id}` ,
        method: 'get',
      })
      return res
    } catch (err) {
      console.log(err, 'show-err')
    }
  }

  // notificationService.editNotifications = async function (userId, data) {
  //   try {
  //     const res = await fetch({
  //       url: `${apiRoute}?userId=${userId}`,
  //       method: 'post',
  //       data: data,
  //     })
  //     return res
  //   } catch (err) {
  //     console.log(err, 'show-err')
  //   }
  // }

  notificationService.createCartReminder= async function (data) {
    // console.log(data);
    try {
      const res = await fetch({
        url:`${apiRoute}/cartreminder`,
        method: 'post',
        data: {userId: data}
      })
      return res
    } catch (err) {
      console.log(err, 'show-err')
    }
  }
  export default notificationService
